export const EditIconLight = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.99984 4.33419L11.6665 7.00085M2.6665 13.3342H5.33317L12.3332 6.33419C12.6868 5.98056 12.8855 5.50095 12.8855 5.00085C12.8855 4.50076 12.6868 4.02114 12.3332 3.66752C11.9795 3.3139 11.4999 3.11523 10.9998 3.11523C10.4997 3.11523 10.0201 3.3139 9.6665 3.66752L2.6665 10.6675V13.3342Z"
        stroke="#99A0AE"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
